// Mirrors the API allowlist so other sources skip a request that would 400.
const THUMBNAIL_HOST = /^(nolan-projects-(development|production)\.s3\.amazonaws\.com|([a-z0-9-]+\.)+fal\.media)$/

export const THUMB_WIDTH = { tile: 480, cover: 960 }

export const thumbnailUrl = (src, width) => {
  const apiHost = process.env.REACT_APP_REST_API_HOST
  if (!apiHost || typeof src !== 'string') return src
  let url
  try {
    url = new URL(src)
  } catch (error) {
    return src
  }
  if (url.protocol !== 'https:' || url.port || !THUMBNAIL_HOST.test(url.hostname)) return src
  return `${apiHost}/media/thumbnail?src=${encodeURIComponent(src)}&w=${width}`
}
